const getters = {
  currentTabApplication:state => state.application.currentTab,
  }
  export default getters